import { Browser } from '@capacitor/browser';
import { isNative } from '@/lib/platform';
import type { CalendarEvent } from '@/types';

const URL_IN_TEXT = /https?:\/\/[^\s<>"')\]]+/i;

/**
 * Joinable URL for an event. Prefers the server-mapped `meetingUrl`
 * (hangoutLink / conferenceData), falling back to a URL pasted into the
 * location field — which also covers events synced before the server
 * started mapping the field.
 */
export function meetingUrlFor(
  event: Pick<CalendarEvent, 'meetingUrl' | 'location'>,
): string | undefined {
  if (event.meetingUrl) return event.meetingUrl;
  const inLocation = event.location?.match(URL_IN_TEXT);
  return inLocation?.[0];
}

/** Open a conference link outside the app: system browser sheet on native, new tab on web. */
export async function openMeetingUrl(url: string): Promise<void> {
  if (isNative()) {
    await Browser.open({ url });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
